import React, { useEffect, useMemo, useState } from "react";
import { getPOOrders, orderInvoice } from "../../../services/apiService";
import logo from "../../../assets/logo.png";

const PrintOrder = () => {
  const [data, setData] = useState([]);
  const [products, setProducts] = useState([]);
  const [invoicedata, setInvoiceData] = useState({});
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  // Pagination state
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await getPOOrders();
      setData(res.data || []);
      setProducts(res.data);
      console.log(res);
    } catch (error) {
      console.error("Warranty list error:", error);
    } finally {
      setLoading(false);
    }
  };

  const Invoice = async (orderid) => {
    try {
      const res = await orderInvoice(orderid);

      const invoice = res?.Ship?.[0] || {};
      const list = res?.data || [];

      // still set state if UI needs it
      setInvoiceData(invoice);
      setList(list);

      // ✅ PASS DATA DIRECTLY
      handlePrintLabel(invoice, list, orderid);

    } catch (error) {
      console.error("Invoice error:", error);
    }
  };

  // ✅ Search Filter
  const filteredData = useMemo(() => {
    const result = !search
      ? [...data]
      : data.filter((row) => {
        const text =
          `${row.id} ${row.orderid} ${row.orderno} ${row.category} ${row.modelno}`
            .toLowerCase()
            .includes(search.toLowerCase());
        return text;
      });

    return result.reverse(); // 👈 flips order
  }, [data, search]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Pagination calculations
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const paginatedData = filteredData?.slice(
    (page - 1) * pageSize,
    page * pageSize,
  );

  const generateLabelHTML = (invoicedata, list, orderid) => {
    const totalQty = list?.reduce((sum, i) => sum + (i.orderqty || 0), 0);

    const rows =
      list
        ?.map(
          (item, index) => `
<tr>
  <td>${index + 1}</td>
  <td>${item?.Products?.[0]?.modelno || "-"}</td>
  <td>${item?.orderqty || 0}</td>
</tr>
`
        )
        .join("") +
      `
<tr>
  <td colspan="2"><strong>Total Quantity</strong></td>
  <td><strong>${totalQty}</strong></td>
</tr>
`;

    return `
<html>
<head>
  <title>Shipping Label</title>

  <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>

  <style>
    body { font-family: Arial; margin: 0; padding: 10px; }
    .label { width: 420px; border: 2px solid #000; padding: 12px; }
    .header { text-align: center; font-weight: bold; }
    .logo { width: 100%; max-height: 30px; object-fit: contain; }

    .row { margin-top: 10px; display: flex; justify-content: space-between; }

    .ship {
      width: 55%;
      font-size: 13px;
      line-height: 1.4;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
      font-size: 13px;
    }

    th, td {
      border: 1px solid #000;
      padding: 5px;
      text-align: center;
    }

    .thanks {
      text-align: center;
      margin-top: 10px;
      font-weight: bold;
    }
  </style>
</head>

<body>
  <div class="label">
    
    <div class="header">
      <img src="${logo}" class="logo" />
    </div>

    <div class="row">
      <div class="ship">
        <strong>Ship To:</strong><br/>
        ${invoicedata?.name || "-"}<br/>
        ${invoicedata?.flathouse || "-"}<br/>
        ${invoicedata?.city || "-"} - ${invoicedata?.pincode || "-"}<br/>
        ${invoicedata?.state || "-"} - ${invoicedata?.country || "-"}<br/>
        ${invoicedata?.phone || "-"}
      </div>

      <div style="text-align:center;">
        <svg id="barcode"></svg>
      </div>
    </div>

    <table>
      <tr>
        <th>S.No</th>
        <th>Product</th>
        <th>Qty</th>
      </tr>
      ${rows}
    </table>

    <div class="thanks">Thank You</div>
  </div>

  <script>
    window.onload = function () {
      JsBarcode("#barcode", "${orderid}", {
        format: "CODE128",
        width: 2,
        height: 50,
        displayValue: true
      });

      setTimeout(() => {
        window.print();
        window.close();
      }, 500);
    };
  </script>

</body>
</html>
`;
  };

  const handlePrintLabel = (invoice, list, orderid) => {
    const printWindow = window.open("", "_blank", "width=1000,height=1600");
    if (!printWindow) return;

    printWindow.document.open();
    printWindow.document.write(
      generateLabelHTML(invoice, list, orderid) // ✅ use fresh data
    );
    printWindow.document.close();
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Header + Search */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "15px",
        }}
      >
        {/* <h2>Warranty Claim</h2> */}
        <div>
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              padding: "6px 10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
        </div>
      </div>

      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              <th>#</th>
              <th>OrderId</th>
              <th>Order Date</th>
              <th>NetAmount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={10}
                  style={{ textAlign: "center", padding: "10px" }}
                >
                  Loading...
                </td>
              </tr>
            ) : paginatedData.length === 0 ? (
              <tr>
                <td
                  colSpan={10}
                  style={{ textAlign: "center", padding: "10px" }}
                >
                  No Data Found
                </td>
              </tr>
            ) : (
              paginatedData.map((row, idx) => (
                <tr
                  key={row.id}
                  style={{ background: idx % 2 === 0 ? "#fff" : "#f9f9f9" }}
                >
                  <td style={{ padding: "16px 8px", color: " #464849;" }}>
                    {idx + 1}
                  </td>
                  <td style={{ padding: "6px 8px", color: " #464849;" }}>
                    {row.orderid}
                  </td>
                  <td style={{ padding: "6px 8px", color: " #464849;" }}>
                    {" "}
                    {new Date(row.orderdate)
                      .toLocaleDateString("en-GB")
                      .replace(/\//g, "-")}
                  </td>
                  <td style={{ padding: "6px 8px" }}>
                    ₹ {Number(row?.netamount || 0).toFixed(2)}
                  </td>
                  <td
                    style={{ cursor: "pointer", color: "#005487" }}
                    onClick={() => Invoice(row.orderid)}
                  >
                    Print
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}

      <div className="pagination-container">
        <div style={{ color: "black" }}>
          Items per page:
          <select
            className="page-select"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}
          >
            {[5, 10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>

        <div className="page-buttons">
          <button
            className="page-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Previous
          </button>

          <span className="page-count">
            {page} / {totalPages || 1}
          </span>

          <button
            className="page-btn"
            disabled={page === totalPages || totalPages === 0}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintOrder;
{
  /* <div style={{display:'none'}}>
        <img src="https://barcode.tec-it.com/barcode.ashx?data=${orderid}&code=Code128&dpi=96" />
        <div>${orderid}</div>
      </div> */
}
